export type Page =
    | { type: "environments" }
    | { type: "environment"; environmentId: string; label: string }
    | { type: "projects" }
    | { type: "automations" }
    | { type: "user-settings" }
    | { type: "org-settings" }
    | { type: "organizations" };

export function pageLabel(page: Page): string {
    switch (page.type) {
        case "environments":
            return "Environments";
        case "environment":
            return page.label;
        case "projects":
            return "Projects";
        case "automations":
            return "Automations";
        case "user-settings":
            return "User Settings";
        case "org-settings":
            return "Organization Settings";
        case "organizations":
            return "Organizations";
    }
}
